var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "603.98 425.98 72.92 72.92",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M661.3,487.8l-17.5-17.5c-1.4,1.1-2.9,1.9-4.7,2.5c-1.8,0.6-3.7,0.9-5.7,0.9c-5.1,0-9.4-1.8-13-5.3   c-3.5-3.5-5.3-7.9-5.3-13c0-5.1,1.8-9.4,5.3-13c3.5-3.5,7.9-5.3,13-5.3c5.1,0,9.4,1.8,13,5.3c3.5,3.5,5.3,7.9,5.3,13   c0,2-0.3,4-0.9,5.7c-0.6,1.8-1.5,3.3-2.5,4.7l17.5,17.5L661.3,487.8z M633.3,467.5c3.3,0,6.2-1.2,8.5-3.5c2.3-2.3,3.5-5.2,3.5-8.5   c0-3.3-1.2-6.2-3.5-8.5c-2.3-2.3-5.2-3.5-8.5-3.5c-3.3,0-6.2,1.2-8.5,3.5c-2.3,2.3-3.5,5.2-3.5,8.5c0,3.3,1.2,6.2,3.5,8.5   C627.1,466.3,630,467.5,633.3,467.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0d8537b695aa40be3f7597d84e7736a9.svg";
export { ForwardRef as ReactComponent };